import React from "react";
import PropTypes from "prop-types";
import { Button, Collapse, Card } from "react-bootstrap";
import { DatePicker } from "antd";
import exceptions from "data/exceptions";
import DraftFiltersItem from "components/schedule/DraftsDetails/draft-filters-item";

class DraftFilters extends React.PureComponent {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.handleFilter = this.handleFilter.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleSetDate = this.handleSetDate.bind(this);

        this.state = {
            isOpen: false,

            startDate: null,
            endDate: null
        };
    }

    handleSetDate = (name, value) => {
        const newState = {};

        newState[name] = value;
        this.setState(newState, () => {
            const dateString = value === null
                ? null
                : value.format(this.dateFormat);
            this.handleFilter(name, dateString);
        });
    };

    handleFilter(filterKey, value, isArray) {
        /*
        const callback = () => {
            this.props.filterCallback(filterKey, value, isArray);
        };

        if (filterKey === "exceptions") {
            this.handleReset(callback);
        } else {
            const { activeFilters } = this.props;
            if (!activeFilters.exceptions || activeFilters.exceptions === null) {
                callback();
            } else {
                this.props.filterCallback("exceptions", null, isArray, callback);
            }
        }
        */

        this.props.filterCallback(filterKey, value, isArray);
    }

    handleSearch () {
        this.setState({
            isOpen: false
        });
        this.props.onSearch();
    }

    handleReset (callback = false) {
        this.setState({
            startDate: null,
            endDate: null
        }, () => {
            this.props.onReset(callback);
        });
    }

    render() {
        const {
            filters,
            activeFilters,
            titleFilteredCounts
        } = this.props;

        const {
            isOpen,
            startDate,
            endDate
        } = this.state;

        const stores = {};
        if (filters.stores) {
            Object.keys(filters.stores).forEach(storeId => {
                stores[storeId] = `${filters.stores[storeId].storeNumber} - ${filters.stores[storeId].retailer}`;
            });
        }

        return (
            <div className="position-relative mb-4" style={{ zIndex: 10 }}>
                <Card className=" mb-2">
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="m-0">
                                {this.props.title}
                            </h4>
                            <div>
                                <span className="text-success mr-3" title="Filtered / Total">
                                    {`${titleFilteredCounts.totalFilteredRecords} / ${titleFilteredCounts.totalRecords}`}
                                </span>
                                <Button
                                    onClick={() => this.setState({ isOpen: !isOpen })}
                                    aria-expanded={isOpen}
                                >
                                    {`${isOpen ? "Close" : "Expand"} Search`}
                                </Button>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Collapse in={isOpen} className="col-12 p-3">
                            <div className="row">
                                <div className="col-9">
                                    <div className="row">
                                        <div className="col-3">
                                            <DraftFiltersItem
                                                label="Province"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("provinceIds", item)}
                                                filterObj={filters.provinces || {}}
                                                valuesObj={activeFilters.provinceIds || false}
                                            />
                                            <DraftFiltersItem
                                                label="City"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("cityIds", item, true)}
                                                filterObj={filters.cities || {}}
                                                valuesObj={activeFilters.cityIds || false}
                                            />
                                            <DraftFiltersItem
                                                label="Store#"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("storeIds", item)}
                                                filterObj={stores}
                                                valuesObj={activeFilters.storeIds || false}
                                            />
                                            <DraftFiltersItem
                                                label="Retailers"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("retailerIds", item)}
                                                filterObj={filters.retailers || {}}
                                                valuesObj={activeFilters.retailerIds || false}
                                            />
                                        </div>
                                        <div className="col-3">
                                            <DraftFiltersItem
                                                label="Jobs"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("jobIds", item)}
                                                filterObj={filters.jobs || {}}
                                                valuesObj={activeFilters.jobIds || false}
                                            />
                                            <DraftFiltersItem
                                                label="Helper Job"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("helperJobIds", item)}
                                                filterObj={filters.helperJobs || {}}
                                                valuesObj={activeFilters.helperJobIds || false}
                                            />
                                            <DraftFiltersItem
                                                label="Merchandiser"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("workerIds", item)}
                                                filterObj={filters.merchandisers || []}
                                                valuesObj={activeFilters.workerIds || false}
                                            />
                                            <DraftFiltersItem
                                                label="Supervisor"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("supervisorIds", item)}
                                                filterObj={filters.supervisors || []}
                                                valuesObj={activeFilters.supervisorIds || false}
                                            />
                                        </div>
                                        <div className="col-3">
{/* <DraftFiltersItem
    label="Product"
    isMulti={true}
    onChange={(item) => this.handleFilter("productIds", item)}
    filterObj={filters.products || {}}
    valuesObj={activeFilters.productIds || false}
/> */}
                                            <DraftFiltersItem
                                                label="Trait"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("traits", item)}
                                                filterObj={filters.traits || []}
                                                valuesObj={activeFilters.traits || false}
                                            />
                                            <DraftFiltersItem
                                                label="Hours"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("hours", item)}
                                                filterObj={filters.hours || []}
                                                valuesObj={activeFilters.hours || false}
                                            />
                                            <div className="mb-1 draft-filter-wrapper form-group">
                                                <label className="d-block mb-0 font-weight-bold form-label">Start Date</label>
                                                <DatePicker
                                                    value={startDate}
                                                    format={this.dateFormat}
                                                    onChange={date => {
                                                        this.handleSetDate("startDate", date);
                                                    }}
                                                    disabledDate={(current) => {
                                                        if (endDate === null) {
                                                            return false;
                                                        }
                                                        return current && current >= endDate;
                                                    }}
                                                    className="d-block"
                                                />
                                            </div>
                                            <div className="mb-1 draft-filter-wrapper form-group">
                                                <label className="d-block mb-0 font-weight-bold form-label">End Date</label>
                                                <DatePicker
                                                    value={endDate}
                                                    format={this.dateFormat}
                                                    onChange={date => {
                                                        this.handleSetDate("endDate", date);
                                                    }}
                                                    disabledDate={(current) => {
                                                        if (startDate === null) {
                                                            return false;
                                                        }
                                                        return current && current <= startDate;
                                                    }}
                                                    className="d-block"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <DraftFiltersItem
                                                label="Exceptions"
                                                isMulti={false}
                                                onChange={(item) => this.handleFilter("exceptions", item)}
                                                filterObj={exceptions}
                                                valuesObj={activeFilters.exceptions || false}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-2 offset-1">
                                    <div className="h-100 d-flex flex-column justify-content-around">
                                        <Button
                                            variant="primary"
                                            onClick={this.handleSearch}
                                        >
                                            Search
                                        </Button>
                                        <Button
                                            variant="secondary"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

DraftFilters.defaultProps = {
    filters: {
        provinces: [],
        cities: [],
        stores: [],
        retailers: [],
        jobs: [],
        helperJobs: [],
        products: [],
        traits: [],
        hours: [],
        merchandisers: [],
        supervisors: [],
    }
};

DraftFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    filterCallback: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    titleFilteredCounts: PropTypes.object.isRequired
};

export default DraftFilters;
